import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { TeamGrid } from "../components/TeamGrid";

const WHATSAPP_HREF = "https://wa.me/393520463627";
const YOUTUBE_HREF = "https://www.youtube.com/channel/UCs68SjdTp0KWzMEiKiHy1sw";
const INSTAGRAM_HREF =
  "https://www.instagram.com/garagedrops?stkn=Nmx4cTIyNmtna3dz&utm_source=qr";

export default function ChiSiamo() {
  return (
    <div style={{ background: "#F2EFE9", minHeight: "100vh", paddingTop: 64 }} data-testid="chi-siamo">
      <section className="px-6 sm:px-12 pt-20 pb-16">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-[820px] mx-auto"
        >
          <div className="text-[11px] uppercase tracking-[0.3em] mb-6" style={{ color: "#FF2800" }}>
            Chi siamo
          </div>
          <h1
            className="text-5xl sm:text-7xl mb-12"
            style={{ color: "#111", fontWeight: 300, letterSpacing: "-0.02em", lineHeight: 1.02 }}
          >
            Federico, Mattia, Emanuele ed&nbsp;Ettore.
          </h1>

          <div className="mb-14">
            <TeamGrid />
          </div>

          <div className="flex flex-col gap-6 text-[18px] sm:text-[20px]" style={{ color: "#2b2b2b", lineHeight: 1.65 }}>
            <p>
              Ci lega la passione per i motori: ci piace raccontarli, mostrarli e viverli.
            </p>
            <p>
              Sul nostro{" "}
              <a
                href={YOUTUBE_HREF}
                target="_blank"
                rel="noreferrer"
                className="underline"
                style={{ color: "#FF2800" }}
                data-testid="chi-siamo-youtube"
              >
                canale YouTube
              </a>{" "}
              raccontiamo auto e moto che ci emozionano: la loro storia, il loro suono, le
              persone che le hanno amate. Ogni video nasce da una domanda semplice: cosa rende
              speciale questo mezzo?
            </p>
            <p>
              La nostra forza è la comunità dell'automobilismo e la passione che ci unisce.
              È la stessa passione che mettiamo in ogni progetto: video, foto e storie
              raccontate al meglio.
            </p>
            <p className="italic" style={{ color: "#5a5a5a" }}>
              Grazie,<br />
              Federico, Mattia, Emanuele, Ettore.
            </p>
          </div>

          {/* Bottoni social + WhatsApp */}
          <div className="mt-14 flex flex-wrap gap-3">
            <a
              href={WHATSAPP_HREF}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center px-7 py-3.5 text-[14px]"
              style={{ background: "#25D366", color: "#FFFFFF", fontWeight: 500 }}
              data-testid="chi-siamo-wa"
            >
              WhatsApp
            </a>
            <a
              href={YOUTUBE_HREF}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center px-7 py-3.5 text-[14px]"
              style={{ background: "#FF0000", color: "#FFFFFF", fontWeight: 500 }}
              data-testid="chi-siamo-yt"
            >
              YouTube
            </a>
            <a
              href={INSTAGRAM_HREF}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center px-7 py-3.5 text-[14px]"
              style={{
                background: "linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)",
                color: "#FFFFFF",
                fontWeight: 500,
              }}
              data-testid="chi-siamo-ig"
            >
              Instagram
            </a>
            <Link
              to="/servizi"
              className="inline-flex items-center px-7 py-3.5 text-[14px]"
              style={{ background: "#111", color: "#FFF" }}
              data-testid="chi-siamo-servizi"
            >
              I nostri servizi
            </Link>
          </div>
        </motion.div>
      </section>
    </div>
  );
}
